export const COMMON_HTTP_ERRORS = {
    E400: { status: 400, message: 'Mock - Bad Request' },
    E401: { status: 401, message: 'Mock - Unauthorized' },
    E402: { status: 402, message: 'Mock - Payment Required' },
    E404: { status: 404, message: 'Mock - Not Found' },
    E422: { status: 422, message: 'Mock - Unprocessable Entity' },
    E500: { status: 500, message: 'Mock - Internal Server Error' },
} as const;

export type MockError = {
    status: number;
    message: string;
    body?: { [key: string]: string };
};

export type MockErrorConfig = {
    [key: string]: {
        [key: string]: MockError;
    };
};

export const mockErrorConfig: MockErrorConfig = {
    oem: {
        // sendVehicleConfig: {
        //     ...COMMON_HTTP_ERRORS.E400,
        // },
    },
    vehicles: {
        createVehicle: COMMON_HTTP_ERRORS.E422,
    },
};
